<template>
    <script v-html="this.jsonlddados" type="application/ld+json">
    </script>
</template>
<script>
    export default {
        methods: {
            init() {
                const self = this;
                var textquestion = '';
                let url = self.$router.history._startLocation;
                if (url !== "") {
                    let xhr = new XMLHttpRequest();
                    xhr.open("GET", this.$apiUrl + "Marketing.svc/getfaq?url=" + url)
                    xhr.setRequestHeader('Content-type', 'application/json')
                    xhr.withCredentials = true
                    xhr.onload = () => {
                        if (xhr.status == 200) {
                            let perguntas = JSON.parse(xhr.responseText);
                            perguntas.forEach((element, index) => {
                                textquestion += '{' +
                                    '        "@type": "Question",' +
                                    '        "name": "' + element.PERGUNTA + '",' +
                                    '        "acceptedAnswer": {' +
                                    '          "@type": "Answer",' +
                                    '          "text": "' + element.RESPOSTA + '"' +
                                    '        }' +
                                    '      },';
                            })
                            if (textquestion != '') {
                                textquestion = textquestion.slice(0, -1);
                                var textFAQ = '"@context": "https://schema.org",' +
                                    '      "@type": "FAQPage",' +
                                    '      "mainEntity": [' + textquestion + ']';
                                this.jsonlddados = JSON.parse('{' + textFAQ + '}');
                            }
                        }
                    }
                    xhr.send();
                }
                
            }
        },
        data() {
            return {
                jsonlddados: ''
            }
        },
        mounted() {
            this.init();
        },
    };

</script>